import type { SVGProps } from 'react';

export type CogIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const CogIcon = ({ size = 13, ...rest }: CogIconProps) => (
  <svg width={size} height={size} viewBox="0 0 12 12" role="img" aria-hidden {...rest}>
    <title>settings</title>
    <circle cx="6" cy="6" r="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M6 1 L6 3 M6 9 L6 11 M1 6 L3 6 M9 6 L11 6 M2.5 2.5 L4 4 M8 8 L9.5 9.5 M2.5 9.5 L4 8 M8 4 L9.5 2.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);
